import { ContactWidget } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/super-agent/components/ContactWidget/ContactWidget";
import { EmailWidget } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/super-agent/components/EmailWidget/EmailWidget";
import type { WidgetConfig } from "app/pages/sales-intelligence/modules/ai-agent/types/superAgent";
import type {
    ContactSearchEntry,
    CRMEntity,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

type Props = {
    config: WidgetConfig | null;
    getMessageContent: () => string;
    setMessageContent: (content: string) => void;
    messageId: string;
    isStreaming: boolean;
    onExportToCRM: (contact: ContactSearchEntry, destination: Integration, as?: CRMEntity) => void;
};

export const ChatWidget = ({
    config,
    getMessageContent,
    setMessageContent,
    messageId,
    isStreaming,
    onExportToCRM,
}: Props) => {
    if (!config) {
        return null;
    }

    const { type, data } = config;

    switch (type) {
        case "widget_contacts":
            return (
                <ContactWidget
                    widgetData={data}
                    getMessageContent={getMessageContent}
                    setMessageContent={setMessageContent}
                    messageId={messageId}
                    isStreaming={isStreaming}
                    onExportToCRM={onExportToCRM}
                />
            );
        case "widget_outreach_email":
            return (
                <EmailWidget
                    widgetData={data}
                    getMessageContent={getMessageContent}
                    setMessageContent={setMessageContent}
                    messageId={messageId}
                    isStreaming={isStreaming}
                />
            );
        case "widget_meeting":
        default:
            return null;
    }
};
